import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { MetaModel, WidgetModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { BatchListDataService } from 'common/services/data-services/custom-service/batch-service';
import { branchListDataService } from 'common/services/data-services/custom-service/branchList-service';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { CompanyGridDataService } from 'common/services/data-services/admin/internship-company/company-grid-data.service';
import { AssignmentReportsDataService } from 'common/services/data-services/admin/reports/assignment-reports.service';
import { LocationGridDataService } from 'common/services/data-services/admin/location/location-grid-data.service';
import { ViewTypesDataService } from 'common/services/data-services/admin/view-type/view-types-data.services';
import { AssignmentReportsModel } from 'common/models/page-models/reports/assignment-reports/assignment-report.data-model';
import { AssignmentReportsGridMetaModel } from 'common/models/page-models/reports/assignment-reports/assignment-reports-grid-meta.model';
import { AssignmentReportsListingModel } from 'common/models/page-models/reports/assignment-reports/assignment-reports-grid-model';
import { TypesGridDataService } from 'common/services/data-services/admin/types/types-grid-data.services';


@Injectable({
    providedIn: 'root'
})
export class AssignmentReportsWidgetService extends GridWidgetService<AssignmentReportsModel, AssignmentReportsListingModel> {
    constructor(protected override ds: AssignmentReportsDataService, protected systemService: SystemService, private batchListService: BatchListDataService, private branchListService: branchListDataService, private stateService: stateListDataService, private companyListService: CompanyGridDataService, private locationListService: LocationGridDataService, private typesListService: TypesGridDataService, private categoryListService: ViewTypesDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new AssignmentReportsGridMetaModel().getMetaModel();
        return meta;
    }

    override prepareMetaModel(dataModel: AssignmentReportsListingModel, metaModel: AssignmentReportsGridMetaModel, routeData: WidgetModel): Promise<AssignmentReportsGridMetaModel> {
        return new Promise<AssignmentReportsGridMetaModel>((resolve, reject) => {
            
            this.batchListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedBatch.options = data.details;
            });
            this.branchListService.postData('').then((data) =>{
                // console.log(metaModel.filterMeta.properties.selectedBranch.options);

                metaModel.filterMeta.properties.selectedBranch.options = data.details;
            });
            this.stateService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedState.options = data.details;
            });
            this.locationListService.postData('').then((data) =>{                
                metaModel.filterMeta.properties.selectedLocation.options = data.details;
            });
            this.typesListService.postData('').then((data) =>{
                metaModel.filterMeta.properties.selectedType.options = data.details;
            });
          
            resolve(metaModel);
        });
    }

}